import {FC} from 'react'
import {CardData} from '../../../type'
import {QRCode} from 'react-qrcode-logo'
import {ENV} from '../../../../../../Utils/_helpers/EnvHelper'
import {useResponsiveCard} from '../useResponsiveCard'
import './PreviewWalletCardGoogle.scss'
import {useI18n} from '../../../../../../Utils/_helpers/useI18n'
import {PreviewWalletCardGoogleProps} from '../../../type'
import {useLocation} from 'react-router-dom'

export const PreviewWalletCardGoogle: FC<PreviewWalletCardGoogleProps> = ({
  cardData,
  customStyles = {},
}) => {
  const isTemplate = useLocation().pathname.includes('card-templates')

  const qrCodeUrl =
    cardData.id && !isTemplate
      ? `${ENV().REACT_APP_FE_URL}/wallet-card/public/${cardData.id}`
      : `${ENV().REACT_APP_FE_URL}/dashboard`
  const {width, height, fontSize, qrSize, avatarSize} = useResponsiveCard()
  const {t} = useI18n()
  return (
    <div className='d-flex justify-content-center preview-wallet-card-google'>
      <div
        className='card-container google-card-container'
        style={{
          width: width,
          height: height,
          fontSize: fontSize,
          ...customStyles,
          backgroundColor: cardData.backgroundColor,
        }}
      >
        {/* Card Header */}
        <div className='card-header-custom'>
          <div className='header-logo d-flex align-items-center gap-5 w-100'>
            <div className='logo-container col-3'>
              {cardData.logoGoogle ? (
                <img
                  src={cardData.logoGoogle}
                  alt='Company Logo'
                  className='company-logo company-logo-google'
                />
              ) : null}
            </div>
            <h5
              className='company-name company-name-google text-truncate col-9'
              style={{fontSize: `calc(${fontSize} * 1.1)`, color: cardData.foregroundColor}}
            >
              {cardData.organizationName}
            </h5>
          </div>
        </div>

        {/* Card Green Content */}
        <div className='card-content'>
          {/* Card Title */}
          <div className='card-title-custom'>
            <h3
              className='card-title-text card-title-text-google single-line-text'
              style={{fontSize: `calc(${fontSize} * 1.3)`, color: cardData.foregroundColor}}
            >
              {cardData.cardLabel}
            </h3>
          </div>

          {/* Card Info */}
          <div className='card-info'>
            <div className='info-section d-flex justify-content-between'>
              <div className='w-50 pe-2 header-content'>
                <div className='info-label fw-bold' style={{color: cardData.labelColor}}>
                  {t('WALLET_CARD.FORM.FULL_NAME')}
                </div>
                <div
                  className='info-value fw-bold single-line-text'
                  style={{color: cardData.foregroundColor}}
                >
                  {cardData.fullName}
                </div>
              </div>
              <div className='text-end w-50 ps-2 header-content'>
                <div className='info-label fw-bold' style={{color: cardData.labelColor}}>
                  {t('WALLET_CARD.FORM.JOB_TITLE')}
                </div>
                <div
                  className='info-value fw-bold single-line-text'
                  style={{color: cardData.foregroundColor}}
                >
                  {cardData.jobTitle}
                </div>
              </div>
            </div>

            <div className='info-section'>
              <div className='col-12 header-content'>
                <div className='info-label fw-bold' style={{color: cardData.labelColor}}>
                  {t('WALLET_CARD.FORM.EMAIL')}
                </div>
                <div
                  className='info-value single-line-text'
                  style={{color: cardData.foregroundColor}}
                >
                  {cardData.email}
                </div>
              </div>
            </div>

            <div className='info-section d-flex justify-content-between'>
              <div className='col-7 header-content'>
                <div className='info-label fw-bold' style={{color: cardData.labelColor}}>
                  {t('WALLET_CARD.FORM.ADDRESS')}
                </div>
                <div
                  className='info-value single-line-text'
                  style={{color: cardData.foregroundColor}}
                >
                  {cardData.address}
                </div>
              </div>
              <div className='text-end ps-2 header-content col-5'>
                <div className='info-label fw-bold' style={{color: cardData.labelColor}}>
                  {t('WALLET_CARD.FORM.PHONE')}
                </div>
                <div
                  className='info-value single-line-text'
                  style={{color: cardData.foregroundColor}}
                >
                  {cardData.phone}
                </div>
              </div>
            </div>

            <div className='info-section d-flex justify-content-between'>
              <div className='w-50 pe-2 header-content'>
                <div className='info-label fw-bold' style={{color: cardData.labelColor}}>
                  {t('WALLET_CARD.FORM.WEBSITE')}
                </div>
                <div
                  className='info-value single-line-text'
                  style={{color: cardData.foregroundColor}}
                >
                  {cardData.website}
                </div>
              </div>
              <div className='text-end w-50 ps-2 header-content'>
                <div className='info-label fw-bold' style={{color: cardData.labelColor}}>
                  {t('WALLET_CARD.FORM.COMPANY_NAME')}
                </div>
                <div
                  className='info-value single-line-text'
                  style={{color: cardData.foregroundColor}}
                >
                  {cardData.companyName}
                </div>
              </div>
            </div>

            {/* QR Code */}
            <div className='qr-code-section-google'>
              <div className='qr-code'>
                <div className='qr-code-inner my-2'>
                  <QRCode value={qrCodeUrl} size={qrSize} bgColor='#ffffff' fgColor='#000000' />
                </div>
              </div>

              {/* Profile Picture */}
              {cardData.pictureGoogle ? (
                <div className='profile-picture'>
                  <img
                    src={cardData.pictureGoogle}
                    alt='Profile'
                    className='profile-image profile-image-google'
                    style={{
                      width: `calc(${avatarSize} * 1.15)`,
                      height: `calc(${avatarSize} * 1.15)`,
                    }}
                  />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
